module.exports = __webpack_public_path__ + "img/5.ae3582cd.png";